import { THEMES } from '@shared/config';

export interface BrandingCustomizationValue {
  brandingCustomizationValueId: number;
  brandingTheme: THEMES;
  brandingCustomizationId: string;
  brandingCustomizationType: BrandingCustomizationValueType;
  value: string;
}

export interface BrandingCustomization {
  brandingCustomizationId: string;
  description: string;
  type: BrandingCustomizationValueType;
}

export enum BrandingCustomizationValueType {
  color = 'color',
  colorList = 'color-list',
  number = 'number',
  numberCss = 'number-css',
  string = 'string',
}

export const buildCustomizationValuesObject = (
  brandingThemeCustomizations: BrandingCustomization[],
  brandingCustomizationValues: BrandingCustomizationValue[]
) => {
  const brandingThemeCustomizationsObject = brandingThemeCustomizations.reduce(
    (acc, brandingThemeCustomization) => {
      return {
        ...acc,
        [brandingThemeCustomization.brandingCustomizationId]:
          brandingThemeCustomization.type,
      };
    },
    {}
  );

  return brandingCustomizationValues.reduce((acc, current) => {
    const value =
      brandingThemeCustomizationsObject[current.brandingCustomizationId] ===
      BrandingCustomizationValueType.colorList
        ? JSON.parse(current.value)
        : current.value;

    return {
      ...acc,
      [current.brandingCustomizationId]: value,
    };
  }, {});
};
